import * as React from "react";
import NewProductionAdManyFlowForm from "../../../components/Forms/NewProductionAdDefaultSetting/FlowForm/FlowForm";

export default function PublishNewProductionAdsDefaultSettings() {
  return <NewProductionAdManyFlowForm />;
}
